"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("../../lib");

var _common = require("../../common");

var _Dimmer = _interopRequireDefault(require("../Dimmer"));

var _Modal = _interopRequireDefault(require("../Modal"));

var _Portal = _interopRequireDefault(require("../Portal"));

var _Toggle = _interopRequireDefault(require("../Toggle"));

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SlideBar =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SlideBar, _PureComponent);

  function SlideBar(props) {
    var _this;

    _classCallCheck(this, SlideBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SlideBar).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getTransition", function (visible) {
      var duration = _this.props.duration;
      return "all ".concat(duration, "ms ease-").concat(visible ? 'out' : 'in');
    });

    _defineProperty(_assertThisInitialized(_this), "getPosition", function (visible) {
      if (visible) {
        return '0';
      }

      return '-27rem';
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnOpen", function (e) {
      var bodyScrollable = _this.props.bodyScrollable;

      if (!bodyScrollable) {
        document.body.classList.add(_Modal.default.fixedScrollClassName);
      }

      if (_this.timer.close) {
        clearTimeout(_this.timer.close);
      }

      _this.setState({
        render: true
      }, function () {
        var current = _this.innerRef.current;

        if (current) {
          var _this$props = _this.props,
              duration = _this$props.duration,
              direction = _this$props.direction;
          current.style[direction] = _this.getPosition(false);
          current.style.transition = _this.getTransition(true); // delay 5 milisecond for animation to register

          setTimeout(function () {
            current.style[direction] = _this.getPosition(true);
          }, 5);
          var onOpen = _this.props.onOpen;
          onOpen(e);
          _this.timer.open = setTimeout(function () {
            // onOpened callback will have slight delay if slidebar opens while closing
            var onOpened = _this.props.onOpened;
            onOpened(e);
          }, duration + 1);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClose", function (e) {
      document.body.classList.remove(_Modal.default.fixedScrollClassName);

      if (_this.timer.open) {
        clearTimeout(_this.timer.open);
      }

      var current = _this.innerRef.current;

      if (current) {
        var _this$props2 = _this.props,
            duration = _this$props2.duration,
            direction = _this$props2.direction;
        current.style[direction] = _this.getPosition(true);
        current.style.transition = _this.getTransition(false);
        current.style[direction] = _this.getPosition(false);
        var onClose = _this.props.onClose;
        onClose(e);
        _this.timer.close = setTimeout(function () {
          // onClosed callback will have slight delay if slidebar closes while opening
          _this.disableRender();

          var onClosed = _this.props.onClosed;
          onClosed(e);
        }, duration + 1);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "disableRender", function () {
      return _this.setState({
        render: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function (toggleProps) {
      var direction = _this.props.direction;
      var names = [SlideBar.className];
      (0, _lib.addClassByPropName)(names, _objectSpread({}, _this.props, {
        visible: toggleProps.active
      }), ['visible']);

      _common.customClassNames.addDirection(names, direction, true);

      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function (_ref) {
      var active = _ref.active,
          toggleOn = _ref.toggleOn,
          toggleOff = _ref.toggleOff,
          toggle = _ref.toggle;
      var children = _this.props.children;
      return (0, _lib.getRenderProps)(children, {
        open: toggleOn,
        close: toggleOff,
        toggle: toggle,
        visible: active
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderDimmer", function (toggleProps) {
      var _this$props3 = _this.props,
          duration = _this$props3.duration,
          dimOverlay = _this$props3.dimOverlay,
          dimOverlayClickable = _this$props3.dimOverlayClickable;
      return _react.default.createElement(_Dimmer.default, {
        active: dimOverlay ? toggleProps.active : false,
        duration: duration,
        fullScreen: true
      }, function (dimmerProps) {
        return _react.default.createElement(_Dimmer.default.Basic, _extends({}, dimmerProps, {
          // TODO: fix transition
          onClick: dimOverlayClickable ? toggleProps.toggleOff : null
        }));
      });
    });

    var _visible = props.visible;
    _this.state = {
      render: _visible
    };
    _this.innerRef = _react.default.createRef();
    _this.timer = {
      open: null,
      close: null
    };
    return _this;
  }

  _createClass(SlideBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var visible = this.props.visible;

      if (visible) {
        this.handleOnOpen();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.classList.remove(_Modal.default.fixedScrollClassName);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          children = _this$props4.children,
          visible = _this$props4.visible,
          duration = _this$props4.duration,
          direction = _this$props4.direction,
          onOpen = _this$props4.onOpen,
          onOpened = _this$props4.onOpened,
          onClose = _this$props4.onClose,
          onClosed = _this$props4.onClosed,
          onToggle = _this$props4.onToggle,
          toggleRef = _this$props4.toggleRef,
          bodyScrollable = _this$props4.bodyScrollable,
          dimOverlay = _this$props4.dimOverlay,
          dimOverlayClickable = _this$props4.dimOverlayClickable,
          rest = _objectWithoutProperties(_this$props4, ["children", "visible", "duration", "direction", "onOpen", "onOpened", "onClose", "onClosed", "onToggle", "toggleRef", "bodyScrollable", "dimOverlay", "dimOverlayClickable"]);

      var render = this.state.render;
      var Wrapper = (0, _lib.getElementType)(this, this.props);
      return _react.default.createElement(_Toggle.default, {
        ref: toggleRef,
        active: visible,
        onToggleOn: this.handleOnOpen,
        onToggleOff: this.handleOnClose,
        onToggle: onToggle
      }, function (toggleProps) {
        var classNames = _this2.classNames(toggleProps);

        if (render) {
          return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Portal.default, null, _react.default.createElement(Wrapper, _extends({}, rest, {
            ref: _this2.innerRef,
            className: classNames
          }), _this2.renderContent(toggleProps))), _this2.renderDimmer(toggleProps));
        }

        return null;
      });
    }
  }]);

  return SlideBar;
}(_react.PureComponent);

exports.default = SlideBar;

_defineProperty(SlideBar, "className", 'MHub-SlideBar');

_defineProperty(SlideBar, "propTypes", {
  as: _common.customPropTypes.as,
  visible: _propTypes.default.bool,
  children: _common.customPropTypes.render,
  direction: _common.customPropTypes.directionHorizontal,
  duration: _propTypes.default.number,
  onOpen: _propTypes.default.func,
  onOpened: _propTypes.default.func,
  onClose: _propTypes.default.func,
  onClosed: _propTypes.default.func,
  onToggle: _propTypes.default.func,
  toggleRef: _common.customPropTypes.ref,
  bodyScrollable: _propTypes.default.bool,
  dimOverlay: _propTypes.default.bool,
  dimOverlayClickable: _propTypes.default.bool
});

_defineProperty(SlideBar, "defaultProps", {
  as: null,
  visible: false,
  children: null,
  direction: 'left',
  duration: 500,
  onOpen: function onOpen() {},
  onOpened: function onOpened() {},
  onClose: function onClose() {},
  onClosed: function onClosed() {},
  onToggle: function onToggle() {},
  toggleRef: null,
  bodyScrollable: false,
  dimOverlay: true,
  dimOverlayClickable: true
});